import CityServiceTemplate from "@/components/CityServiceTemplate";
import newBraunfelsHero from "@/assets/cities/new-braunfels-hero.jpg";

const CarServiceNewBraunfels = () => {
  return (
    <CityServiceTemplate
      cityName="New Braunfels"
      cityDescription="Professional black car service connecting New Braunfels to San Antonio International Airport, downtown San Antonio, and beyond. Whether you're visiting the Comal River, attending a business meeting, or need airport transportation, Rick's provides reliable luxury service."
      metaDescription="Premium black car service in New Braunfels, TX. Airport transfers, point-to-point & hourly chauffeur. Book today!"
      canonicalPath="/new-braunfels-car-service"
      heroImage={newBraunfelsHero}
      additionalContent="New Braunfels residents and visitors choose Rick's Black Car Service for seamless transportation to San Antonio attractions, business districts, and SAT Airport. Our chauffeurs know the area well and provide prompt, professional service for both business and leisure travel."
      coordinates={{
        latitude: 29.7030,
        longitude: -98.1245
      }}
      serviceRadius="35 miles"
      featuredPricing={{
        route: "New Braunfels ↔ SAT Airport",
        price: "~35 mi",
        note: "Pricing based on distance & time (includes 20% gratuity)"
      }}
      cityReviews={[
        {
          author: "Karen Mueller",
          rating: 5,
          date: "2024-11-20",
          text: "Perfect service from New Braunfels to SAT Airport! Rick was waiting exactly when we needed him and got us to our flight with time to spare. The ride was comfortable and professional."
        },
        {
          author: "Tom Bradley",
          rating: 5,
          date: "2024-10-15",
          text: "We hired Rick for transportation during our Gruene Hall wedding weekend. He handled all our guests flawlessly between New Braunfels hotels and the venue. Highly professional!"
        }
      ]}
    />
  );
};

export default CarServiceNewBraunfels;
